import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Container = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  marginTop: "5px",
});
